export const STATUS = {
    PAUSED: 'paused',
    PLAYING: 'playing',
};
